module.exports = __webpack_public_path__ + "static/media/partner-store-list-ic1.e97a4b65.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/partner-store-list-ic1.png
// module id = 542
// module chunks = 0